var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidebar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c2e8ff",
    d: "M7.5 1.5H14.5V14.5H7.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7496c4",
    d: "M14,2v12H8V2H14 M15,1H7v14h8V1L15,1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8bb7f0",
    d: "M1.5 1.5H7.5V14.5H1.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4e7ab5",
    d: "M7,2v12H2V2H7 M8,1H1v14h7V1L8,1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 6H7V8H2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2e8ff",
    d: "M3 3A1 1 0 1 0 3 5 1 1 0 1 0 3 3zM6 3A1 1 0 1 0 6 5 1 1 0 1 0 6 3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebar);
export default __webpack_public_path__ + "static/media/sidebar.ad87d007d961fe5648ca5d7d55632589.svg";
export { ForwardRef as ReactComponent };